/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import {LogLevel} from "@azure/msal-browser";

const azureAdUrlDomain = process.env.NEXT_PUBLIC_AZURE_URL_AD_DOMAIN;
const azureAdSignInPolicy = process.env.NEXT_PUBLIC_AZURE_SIGN_IN_POLICY;
const azureAdClientId = process.env.NEXT_PUBLIC_AZURE_CLIENT_ID;
const azureAdScopes = process.env.NEXT_PUBLIC_SCOPE;
//
/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const b2cPolicies = {
  names: {
    signUp: "B2C_1_signup",
    signIn: "B2C_1_signin",
    forgotPassword: "b2c_1_reset",
    editProfile: "b2c_1_edit_profile",
  },
  authorities: {
    signUp: {
      authority: `https://temp-azure-account.b2clogin.com/${azureAdUrlDomain}.onmicrosoft.com/B2C_1_signup`,
    },
    // signIn: {
    //   authority:
    //     "https://temp-azure-account.b2clogin.com/q22apptest.onmicrosoft.com/B2C_1_signin",
    // },
    // forgotPassword: {
    //   authority:
    //     "https://fabrikamb2c.b2clogin.com/fabrikamb2c.onmicrosoft.com/b2c_1_reset",
    // },
    // editProfile: {
    //   authority:
    //     "https://fabrikamb2c.b2clogin.com/fabrikamb2c.onmicrosoft.com/b2c_1_edit_profile",
    // },
  },
  authorityDomain: `${azureAdUrlDomain}.b2clogin.com`,
};

export const msalConfig = {
  auth: {
    clientId: azureAdClientId,
    authority: `https://${azureAdUrlDomain}.b2clogin.com/${azureAdUrlDomain}.onmicrosoft.com/${azureAdSignInPolicy}`,
    redirectUri: "/pending",
    navigateToLoginRequestUrl: false,
    knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
  },
  cache: {
    // cacheLocation: "sessionStorage", // This configures where your cache will be stored
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const protectedResources = {
  apiHello: {
    endpoint: "http://localhost:5000/hello",
    scopes: azureAdScopes.split(","), // e.g. api://xxxxxx/access_as_user
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: [...protectedResources.apiHello.scopes],
  authority: `https://${azureAdUrlDomain}.b2clogin.com/${azureAdUrlDomain}.onmicrosoft.com/${azureAdSignInPolicy}`,
  // redirectUri: "/register",
  // redirectStartPage: "/register",
  extraQueryParameters: {ui_locales: "en" }
};

export const registerRequest = {
  scopes: [...protectedResources.apiHello.scopes],
  authority: `https://${azureAdUrlDomain}.b2clogin.com/${azureAdUrlDomain}.onmicrosoft.com/${azureAdSignInPolicy}`,
  extraQueryParameters: {ui_locales: "en"}
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};



